module.exports = __webpack_public_path__ + "img/arrowUpRight.0ef7f0e9.svg";